import i18n from '@/i18n';

export function formatWorkTimeDuration(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return i18n.t('{{hours}}h {{minutes}}m', {hours, minutes});
}
